import axios from 'axios';
import store from '@/store/index.js';
import { CustomToast } from '@/utils/sspai-ui.js';
// 创建axios实例
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? 'https://neo.sspai.com/api/v1' : `${window.location.origin}/api/v1`,
  timeout: 15000
});

// request拦截器
service.interceptors.request.use((config) => {
  const token = window.localStorage.getItem('ssToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
},
(error) => {
  Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use(
  (response) => {
    if (response.data.error !== 0) {
      CustomToast({
        message: response.data.msg,
        type: 'error'
      });
    }
    return response.data;
  },
  (error) => {
    if (error && error.response && error.response.status === 401) {
      store.commit('logout');
    }
    return Promise.reject(error);
  }
)
export default service
